import { useEffect, useState } from "react";
import AppLayout from "../layout/AppLayout";
import BackPageConfig from "./BackPageConfig";
import CoverPageConfig from "./CoverPageConfig";
import Cookies from "js-cookie";
import regenerateToken from "../regenerateToken";
import { buildRequestConfig } from "../../utils/apiHelper";
import { isAdmin as checkAdmin } from "../../utils/authUtils";
import axios from "axios";
import Loader from "../loader/loader";
import { positions, useAlert } from "react-alert";
import { useAccessConfig } from "../layout/AccessContext";
import { useAdmin } from "../layout/AdminContext";
import AccessRestricted from "../layout/AccessRestricted";
import "./assetManagement.css";

const AssetManagement = () => {
  const { accessConfig, loading: accessLoading } = useAccessConfig();
  const { isAdmin } = useAdmin();
  const alert = useAlert();
  const [stateConfig, setStateConfig] = useState("");
  const [stateLoader, setStateloader] = useState(false);

  const getStateConfiguration = async () => {
    const url = "https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/config/state";
    // ── ADMIN PATH: use admin token + inject clientId if a client is selected
    if (checkAdmin()) {
      return await axios(buildRequestConfig({ method: "GET", url }));
    }
    // ── CLIENT PATH (unchanged) ──────────────────────────────────────────
    const idToken = Cookies.get("idToken");
    return await axios({
      headers: { authorization: idToken },
      method: "GET",
      url,
      validateStatus: (status) => status >= 200 && status <= 401,
    });
  };

  async function retrieveExistingStateConfiguration() {
    setStateloader(true);
    try {
      const response = await getStateConfiguration();

      const statusCode = response.status;
      if (statusCode === 401) {
        // API Call is to be made for regenerating the ID Token.
        await regenerateToken();
        const retryResponse = await getStateConfiguration();
        const data = retryResponse.data;
        if (data.isSuccess) {
          setStateConfig(data.data.stateData);
        }
      } else {
        const data = response.data;
        if (data.isSuccess) {
          setStateConfig(data.data.stateData);
        }
      }
    } catch (error) {
      console.log("error", error.message);
      alert.error(
        <span className="alertError">
          Failed to load state data. Please try again
        </span>,
        {
          position: positions.TOP_CENTER,
        }
      );
    } finally {
      setStateloader(false);
    }
  }

  useEffect(() => {
    // Only fetch if user has access (admins always have access)
    if (!accessLoading && (isAdmin || accessConfig.assetManagement)) {
      retrieveExistingStateConfiguration();
    }
  }, [accessLoading, accessConfig.assetManagement, isAdmin]);

  // Access control check - show restricted page if no access (after all hooks)
  // Admins are never restricted
  if (!isAdmin && !accessLoading && !accessConfig.assetManagement) {
    return <AccessRestricted featureName="Asset Management" />;
  }

  return (
    <AppLayout>
      {stateLoader || accessLoading ? (
        <Loader />
      ) : (
        <div className="am-container">
          <div className="am-header">
            <div className="am-title">
              <h2>Asset Management</h2>
              <p>Manage your report assets including Back Pages and Cover Pages.</p>
            </div>
          </div>

          <BackPageConfig
            backpageMap={stateConfig?.backpageMap}
            retrieveExistingStateConfiguration={
              retrieveExistingStateConfiguration
            }
          />

          <CoverPageConfig
            coverpageMap={stateConfig.coverpageMap}
            retrieveExistingStateConfiguration={
              retrieveExistingStateConfiguration
            }
          />
        </div>
      )}
    </AppLayout>
  );
};

export default AssetManagement;
